// extracted by mini-css-extract-plugin
export var articleContainer = "index-module--articleContainer--rCaPh";
export var btnContainer = "index-module--btnContainer--UBJHo";
export var container = "index-module--container--onY3d";